
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12690',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12690",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9768",
  "foundations-components": "static-1.8137",
  "foundations-components-legacy": "static-1.1162",
  "foundations-theming": "static-1.4535",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8124",
  "hub-http-shared-msw-handlers": "static-1.10215",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11580",
  "I18n": "static-7.1636",
  "jasmine-runner": "static-1.6564",
  "marketplace-storefront-base": "static-1.12753",
  "quartz": "static-1.7162",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16788",
  "reactive-variable-buffer-atom": "static-1.2964",
  "reporting-testing-lib": "static-1.9901",
  "settings-ui-lib": "static-1.12626",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7326",
  "ui-addon-i18n": "static-1.11255",
  "ui-addon-react-router-dom": "static-1.9644",
  "unified-auth": "static-1.618",
  "unified-auth-core-lib": "static-1.900",
  "usage-tracker": "static-1.7454",
  "usage-tracker-core": "static-1.7304",
  "customer-data-property-utils": "static-1.8201",
  "hub-http": "static-1.6328",
  "integrations-lib": "static-1.16487",
  "marketplace-ui-common": "static-1.20121",
  "property-management-iframe": "static-1.13514",
  "quartz-config": "static-1.940",
  "quartz-core": "static-1.6381",
  "quartz-routing": "static-1.592",
  "quick-fetch": "static-1.3994",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4761",
  "ts-schema": "static-1.4157",
  "ui-universal-auth": "static-1.9104",
  "UIComponents": "static-3.8526",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3475",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3439",
  "quartz-webpack": "static-1.3386",
  "bend-plugin-quartz-routing": "static-1.240",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4406",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4978",
  "foundations-theming-specialty": "static-1.2251",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9528",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.34",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5419",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2182",
  "ui-fonts": "static-1.842",
  "ui-images": "static-2.1179",
  "bend-plugin-foundations-theming": "static-1.3018",
  "foundations-theming-base": "static-1.3520",
  "stylex": "static-1.34",
  "HeadJS": "static-2.767",
  "hs-test-utils-bend-plugin": "static-1.3235",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4432",
  "ai-components-ui-library": "static-1.9210",
  "ai-rendering-library": "static-1.10537",
  "chirp-fetch": "static-1.1992",
  "connections-embed-lib": "static-1.1184",
  "copilot-toolkit": "static-1.11397",
  "feedback-loader": "static-1.29488",
  "laboratory-lib": "static-3.7258",
  "marketplace-embed": "static-1.22416",
  "marketplace-ui-details": "static-1.10016",
  "marketplace-ui-reviews": "static-1.20076",
  "marketplace-ui-tracking": "static-1.14291",
  "sanitize-text": "static-1.8250",
  "ui-addon-video-player": "static-1.8809",
  "usage-tracker-multi": "static-1.5868",
  "usage-tracker-session-replay": "static-1.5140",
  "wootric-nps": "static-1.7060",
  "quartz-head": "static-1.827",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4758",
  "immer": "static-1.33",
  "immerable": "static-1.4257",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2564",
  "reporting-data": "static-1.67968",
  "cssUtils": "static-1.822",
  "flux-actions": "static-1.345",
  "HubStyle": "static-2.11887",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10314",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10468",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7444",
  "icons": "static-2.653",
  "marketplace-ui-apps-core": "static-1.18653",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4618",
  "foundations-components-test-utils": "static-1.5620",
  "quartz-i18n": "static-1.837",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.333",
  "google-sheets-integration-lib": "static-1.537",
  "microsoft-drive-integration-lib": "static-1.673",
  "slack-ui-library": "static-1.10500",
  "fsm": "static-1.3835",
  "customer-data-objects": "static-1.7785",
  "property-translator": "static-1.5503",
  "hs-locale-management": "static-1.159",
  "frontend-preferences-client": "static-1.8033",
  "hs-promise-utils": "static-1.5697",
  "hubspot-apollo-client": "static-1.4984",
  "integrations-error-boundary-lib": "static-1.13902",
  "integrations-tracking-lib": "static-1.5712",
  "native-integrations-shared-strings": "static-1.7889",
  "reselect": "static-2.16",
  "sanitize": "static-1.4582",
  "superstore": "static-1.4866",
  "ui-shepherd-react": "static-3.10332",
  "ai-settings-ui-library": "static-1.8051",
  "hub-http-janus": "static-1.843",
  "hubspotter-http": "static-1.4728",
  "immutable-less": "static-1.4759",
  "marketplace-ui-client-types": "static-1.17528",
  "nav-meta": "static-1.29905",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18139",
  "inbound-db-properties-service-client": "static-1.3922",
  "property-management-common": "static-1.5802",
  "ui-addon-iframeable": "static-1.9170",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.542",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.837",
  "quartz-test": "static-1.837",
  "quartz-tracking": "static-1.541",
  "trellis-components": "static-1.2201",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.171",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21787",
  "ContentUtils": "static-1.68655",
  "customer-data-objects-ui-components": "static-1.13136",
  "sassPrefix": "static-1.158",
  "breeze-engine-core": "static-1.350",
  "breeze-onboarding-components": "static-1.216",
  "avatar-components": "static-1.2604",
  "customer-data-filters-ui": "static-1.40139",
  "customer-data-reference-ui-components": "static-1.13278",
  "embedded-academy-lib": "static-1.14672",
  "ExportDialog": "static-6.10486",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41561",
  "reporting-snowflake": "static-1.56586",
  "reporting-ui-components": "static-2.65239",
  "reporting-visualizations": "static-1.60044",
  "trellis-theming": "static-1.1047",
  "ui-addon-teams": "static-1.21688",
  "integrations-reconnect-lib": "static-1.157",
  "magpie-lib": "static-1.5621",
  "navigation-components": "static-1.18268",
  "breeze-engine-lib": "static-1.1072",
  "magpie-types": "static-1.5081",
  "simple-logging-lib": "static-1.3156",
  "ai-studio-lib": "static-1.11912",
  "app-governance-lib": "static-1.1878",
  "developer-experience-shared-components": "static-1.10620",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8111",
  "ui-product-approvals": "static-1.28566",
  "ui-tool-access": "static-1.10254",
  "usage-based-billing-components-lib": "static-1.9377",
  "usage-tracker-anonymous": "static-1.5871",
  "usage-tracker-public": "static-1.7265",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3663",
  "persist-promise": "static-1.3805",
  "reference-resolvers": "static-1.8280",
  "ui-extensibility-client-types": "static-1.4031",
  "hubspot-apollo-cache": "static-1.443",
  "universal-page-editor-lib": "static-1.3124",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3065",
  "atom": "static-1.5180",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6075",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1648",
  "crm-component-utils": "static-1.39348",
  "crm-properties-common-lib": "static-1.5995",
  "customer-data-properties": "static-1.51929",
  "framework-data-schema-resolvers": "static-1.6997",
  "property-value-citations": "static-1.2543",
  "reference-resolvers-lite": "static-1.8204",
  "ui-business-units-lib": "static-1.9168",
  "navigation-messaging": "static-1.7595",
  "hubspotter-http-shared-msw-handlers": "static-1.10213",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4919",
  "content-icons-ui": "static-1.2256",
  "customer-data-ui-utilities": "static-1.9931",
  "conversations-skeleton-state": "static-1.7354",
  "crm-message-bus": "static-1.43245",
  "customer-data-filters-ui-msw-helpers": "static-1.22574",
  "events-data-lib": "static-1.338",
  "FormUrlGenerator": "static-2.4827",
  "framework-builder-read-service-client": "static-1.4081",
  "framework-data-schema-quick-fetch": "static-1.6902",
  "multi-account-reference-resolvers": "static-1.1088",
  "onboarding-tours": "static-1.16795",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13972",
  "academy-common-lib": "static-1.14132",
  "content-assistance-lib": "static-1.7918",
  "dashboard-lib": "static-1.81930",
  "file-manager-components": "static-1.23902",
  "getting-started-shared-tasks": "static-1.18697",
  "hubspot-prosemirror": "static-1.18515",
  "hubspot-prosemirror-plugins": "static-1.18507",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20010",
  "share-with-third-party-component-lib": "static-1.8810",
  "ui-addon-draggable": "static-3.4866",
  "ui-asset-management-lib": "static-1.11168",
  "user-context": "static-1.5216",
  "growth-payments-core": "static-1.25678",
  "reporting-plugins": "static-1.10495",
  "reporting-reports": "static-1.67646",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.831",
  "nest": "static-1.338",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10733",
  "framework-listing-lib": "static-2.28981",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30957",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4358",
  "react-dnd-compat": "static-1.4721",
  "ui-product-approvals-common": "static-1.461",
  "onboarding-scopes": "static-1.6566",
  "onboarding-tours-client": "static-1.5009",
  "platform-infra-nav-components": "static-1.7749",
  "subscription-experience-data-types": "static-1.15056",
  "crm-record-cards-service-types": "static-1.3666",
  "location-customization-utils-lib": "static-1.9560",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6078",
  "signup-constants": "static-1.19082",
  "signup-ui-url-generator": "static-2.8163",
  "card-properties-lib": "static-1.44500",
  "commerce-subscription-lib": "static-1.37391",
  "crm-actions": "static-1.6445",
  "crm-cards-sdk": "static-1.43883",
  "customer-data-properties-shared-msw-handlers": "static-1.9542",
  "customer-data-tracking": "static-1.6995",
  "hs-resources": "static-1.279",
  "pulse": "static-1.702",
  "calling-global-api": "static-1.64864",
  "calling-internal-common": "static-1.31416",
  "calling-lifecycle-internal": "static-1.66246",
  "calling-lifecycle-messages": "static-1.58540",
  "commerce-products-lib": "static-1.9929",
  "conditional-properties-service-client": "static-1.3873",
  "crm-links": "static-1.6413",
  "crm-pipelines-api-client-types": "static-1.4215",
  "external-options-client-types": "static-1.4206",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4294",
  "meetings-icalendar-utils-lib": "static-1.740",
  "multi-currency-client-types": "static-1.3767",
  "object-builder-ui-client": "static-1.49097",
  "pipeline-validation-client-types": "static-1.4043",
  "smart-property-lib": "static-1.7739",
  "tiered-pricing": "static-1.1477",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11095",
  "fdsr-migration-layer": "static-1.116",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1136",
  "growth-data-modal": "static-1.5593",
  "growth-onboarding-confetti": "static-1.3171",
  "growth-onboarding-next-action-utils": "static-1.2218",
  "onboarding-tours-utils": "static-1.861",
  "ui-shepherd-tracker": "static-1.7713",
  "academy-service-client": "static-1.3789",
  "SafeStorage": "static-1.4505",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39401",
  "FileManagerLib": "static-1.39542",
  "video-embed": "static-1.36103",
  "ui-coaching-tips": "static-1.28845",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11611",
  "video-data-lib": "static-1.35269",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23790",
  "ui-addon-emoji-picker": "static-1.9992",
  "EmailSignatureEditor": "static-1.24598",
  "viral-links-lib": "static-1.7175",
  "data-token-picker": "static-1.16589",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.329",
  "timezone-utils": "static-2.5348",
  "seat-types-lib": "static-1.251",
  "getting-started-shared-tasks-store": "static-1.17815",
  "ui-addon-opt": "static-4.8467",
  "campaign-roi-lib": "static-1.9390",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25658",
  "framework-data-table": "static-2.12149",
  "marketing-platform-lib": "static-1.6972",
  "nudge-client-utils": "static-1.2797",
  "nudge-custom-ui-functions": "static-1.1210",
  "switchboard-lib": "static-1.329",
  "app-users-service-client": "static-1.5714",
  "app-users-service-types": "static-1.5122",
  "mini-checkout-client": "static-1.27066",
  "onboarding-utils": "static-1.5465",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28830",
  "edison-service-client-types": "static-1.495",
  "crm_data": "static-4.92280",
  "customer-data-sidebar": "static-2.46296",
  "enrichment-properties-lib": "static-1.16857",
  "ui-addon-draggable-compat": "static-2.4365",
  "universal-record-utils-lib": "static-1.1204",
  "commerce-billing-lib": "static-1.19410",
  "commerce-shared-components-lib": "static-1.18777",
  "commerce-tools-ui-lib": "static-1.10651",
  "crm-fe-perf": "static-1.23010",
  "event-emitter": "static-1.1056",
  "bend-plugin-pulse": "static-1.205",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31423",
  "shared-worker-versioning": "static-1.11141",
  "calling-usage-tracker": "static-1.6649",
  "voice-sms-access-library": "static-1.1400",
  "commerce-permissions": "static-1.883",
  "products-iframe-lib": "static-1.8218",
  "products-ui-components-shared-msw-handlers": "static-1.10597",
  "data-agent-kit": "static-1.363",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10298",
  "policy-lib": "static-1.6888",
  "react-tinymce": "static-1.55513",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10361",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54639",
  "tinymce-plugins": "static-1.57753",
  "tinymce-themes": "static-1.56609",
  "onboarding-data-sync-lib": "static-1.2138",
  "growth-onboarding-next-action-components": "static-1.2246",
  "user-context-client": "static-1.4687",
  "audio-components": "static-1.6075",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37053",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4642",
  "video-components": "static-1.13613",
  "outpost": "static-1.4276",
  "growth-onboarding-feedback-components": "static-1.6685",
  "content-media-composition-data-lib": "static-1.12636",
  "content-media-compositions": "static-2.16643",
  "media-bridge-lib": "static-1.19105",
  "commerce-tours-lib": "static-1.6288",
  "growth-onboarding-reliability": "static-1.5187",
  "sales-checkout-service-client": "static-1.3698",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21857",
  "sales-email-signature-service-client": "static-1.3955",
  "ts-utils-lib": "static-1.278",
  "crm-export-dialog": "static-1.6391",
  "crm-index-associations-lib": "static-1.6547",
  "crm-view-components": "static-1.586",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7436",
  "nudge-custom-function-registry": "static-1.2554",
  "nudge-renderer-utils": "static-1.2873",
  "whisper-core-api": "static-1.6845",
  "InboxConnectUtils": "static-4.15080",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5777",
  "settings-content-modals": "static-1.46371",
  "crm_universal": "static-1.22189",
  "customer-data-email": "static-1.18218",
  "card-payment-highlight-lib": "static-1.37461",
  "card-subscription-highlight-lib": "static-1.39814",
  "commerce-contract-lib": "static-1.12565",
  "invoices-highlight-card-lib": "static-1.55058",
  "orders-highlight-card-lib": "static-1.21748",
  "products-highlight-card-lib": "static-1.18212",
  "quotes-highlight-card-lib": "static-1.72357",
  "crm-source-interpretation-lib": "static-1.5449",
  "crm-object-search-query-utilities": "static-1.9811",
  "utility-belt": "static-1.2638",
  "payments-enrollment-embed-lib": "static-1.23214",
  "stripe-embedded-components": "static-1.7691",
  "customer-data-rte": "static-1.33264",
  "cv-backend-services": "static-1.1558",
  "growth-onboarding-empty-states": "static-1.5929",
  "payments-post-enroll-local-storage-lib": "static-1.5212",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38447",
  "trials-service-types": "static-1.3987",
  "calling-orchestration-schema": "static-1.36177",
  "sales-views-client-types": "static-1.4362",
  "hub-http-contrib": "static-1.3148",
  "interframe": "static-3.4866",
  "tinymce-data": "static-1.40724",
  "ui-addon-sales-email": "static-1.5316",
  "layout-dnd-components": "static-1.12643",
  "layout-dnd-utils": "static-1.11618",
  "ui-brand-identity-lib": "static-1.15644",
  "NamespacedHubStyle": "static-2.9133",
  "meetings-connect-utils-lib": "static-1.7710",
  "social-insights-client-types": "static-1.22323",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4273",
  "checkout-sdk": "static-3.23909",
  "checkout-service-types": "static-1.3874",
  "company-details-components": "static-1.6303",
  "payment-method-components": "static-1.6979",
  "pricing-pages-ui-components": "static-1.14657",
  "quote-checkout-service-types": "static-1.3570",
  "upgrade-catalog-service-types": "static-1.3628",
  "access-control-lib": "static-1.10540",
  "EmailComponents": "static-1.55049",
  "EmailData": "static-1.53726",
  "redux-less": "static-2.9588",
  "sequences-lib": "static-1.8227",
  "ui-gdpr-components": "static-1.10457",
  "products-ui-components": "static-1.40447",
  "accounting-integrations-ui-components": "static-1.7232",
  "invoices-ui-lib": "static-1.55074",
  "commerce-products-api": "static-1.2445",
  "invoices-iframe-lib": "static-1.57132",
  "quotes-modal-lib": "static-1.103035",
  "quotes-ui-lib": "static-1.81078",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28533",
  "ContentData": "static-1.68730",
  "layout-data-lib": "static-1.9943",
  "hub-http-rxjs": "static-1.808",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4043",
  "billing-payments-client-types": "static-1.4097",
  "react-performance-metrics-lib": "static-1.661",
  "account-and-billing-fintech-outages": "static-3.18710",
  "pricing-pages-api": "static-1.14522",
  "ContentComponents": "static-2.71611",
  "marketing-contacts-lib": "static-1.10387",
  "marketing-email-service-types": "static-1.1982",
  "messaging-editing-lib": "static-1.46558",
  "messaging-usage-based-billing-components-lib": "static-1.1420",
  "automation-ui-source-apps": "static-1.19178",
  "automation-ui-types": "static-1.20096",
  "messaging-types-lib": "static-1.46295",
  "onboarding-settings-client": "static-1.4608",
  "sequences-client-types-lib": "static-1.8084",
  "commerce-tax-lib": "static-1.642",
  "price-books-api": "static-1.1202",
  "price-books-components": "static-1.1260",
  "property-description-translator": "static-1.3947",
  "ramp-editor": "static-1.411",
  "commerce-analytics-service-client": "static-1.3686",
  "totals-ui-components": "static-1.23876",
  "SalesContentIndexUI": "static-3.9393",
  "advanced-menus-core": "static-1.15295",
  "advanced-menus-lib": "static-1.12209",
  "ui-memberships-settings-lib": "static-1.34321",
  "segments-query-core": "static-1.1526",
  "automation-ui-ubb": "static-1.6012",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7444",
  "data-token-views": "static-1.16570",
  "forms-utils-lib": "static-1.12777",
  "payments-embed-points-lib": "static-1.13246",
  "simple-menus-core": "static-1.15294",
  "simple-menus-lib": "static-1.16811",
  "videoconference-integration-components": "static-1.6967",
  "marketing-contacts-client": "static-1.7619",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2629",
  "ContentEditorUI": "static-2.77395",
  "short-messages-app-service-client": "static-1.4030",
  "web-interactives-components": "static-1.13941",
  "web-interactives-data": "static-1.13942",
  "messaging-shared-utils-lib": "static-1.869",
  "messaging-user-info-utils-lib": "static-1.1039",
  "email-portal-health-service-types": "static-1.1082",
  "line-items-api": "static-1.847",
  "commerce-totals-service-types": "static-1.3895",
  "FireAlarmUi": "static-1.4585",
  "sales-templates-service-types-lib": "static-1.4246",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22032",
  "automation-ui-usage-tracking": "static-1.21495",
  "data-studio-ubb": "static-1.3016",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27252",
  "collaboration-sidebar": "static-1.58139",
  "content-management-data-lib": "static-1.5578",
  "copilot-plugins": "static-1.11370",
  "cta-picker": "static-1.36670",
  "customer-agent-discovery-components-lib": "static-1.3380",
  "editor-components": "static-1.13377",
  "editor-iframe-lib": "static-1.8544",
  "error-messaging-js": "static-1.5297",
  "FormsCommonComponents": "static-1.86111",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10752",
  "SharedLegalStrings": "static-1.1851",
  "smart-content-core": "static-1.42717",
  "smart-content-lib": "static-1.43370",
  "social-composer-lib": "static-1.59525",
  "structured-content-lib": "static-1.25461",
  "theme-previewer-lib": "static-1.53521",
  "tinymce-copilot": "static-1.16707",
  "xray-recommendation-lib": "static-1.8043",
  "automation-ui-routing": "static-1.21453",
  "sql-reporting-client-types": "static-1.5721",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42414",
  "campaigns-utils-lib": "static-1.3295",
  "reporting-enablement": "static-1.23277",
  "chatspot-widget-iframe": "static-1.21778",
  "collaboration-sidebar-common": "static-1.2936",
  "forms-ai-lib": "static-1.4481",
  "codemirror-dlb": "static-1.58954",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6541",
  "report-customization-components": "static-1.13449",
  "data-quality-ui-library": "static-1.13300",
  "reporting-filters": "static-1.577",
  "reporting-insights-lib": "static-1.2041"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12690",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9768",
  "foundations-components": "/foundations-components/static-1.8137",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1162",
  "foundations-theming": "/foundations-theming/static-1.4535",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8124",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10215",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11580",
  "I18n": "/I18n/static-7.1636",
  "jasmine-runner": "/jasmine-runner/static-1.6564",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12753",
  "quartz": "/quartz/static-1.7162",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16788",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2964",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9901",
  "settings-ui-lib": "/settings-ui-lib/static-1.12626",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7326",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11255",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9644",
  "unified-auth": "/unified-auth/static-1.618",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.900",
  "usage-tracker": "/usage-tracker/static-1.7454",
  "usage-tracker-core": "/usage-tracker-core/static-1.7304",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8201",
  "hub-http": "/hub-http/static-1.6328",
  "integrations-lib": "/integrations-lib/static-1.16487",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20121",
  "property-management-iframe": "/property-management-iframe/static-1.13514",
  "quartz-config": "/quartz-config/static-1.940",
  "quartz-core": "/quartz-core/static-1.6381",
  "quartz-routing": "/quartz-routing/static-1.592",
  "quick-fetch": "/quick-fetch/static-1.3994",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4761",
  "ts-schema": "/ts-schema/static-1.4157",
  "ui-universal-auth": "/ui-universal-auth/static-1.9104",
  "UIComponents": "/UIComponents/static-3.8526",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3475",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3439",
  "quartz-webpack": "/quartz-webpack/static-1.3386",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.240",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4406",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4978",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2251",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9528",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.34",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5419",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2182",
  "ui-fonts": "/ui-fonts/static-1.842",
  "ui-images": "/ui-images/static-2.1179",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3018",
  "foundations-theming-base": "/foundations-theming-base/static-1.3520",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.767",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3235",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4432",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9210",
  "ai-rendering-library": "/ai-rendering-library/static-1.10537",
  "chirp-fetch": "/chirp-fetch/static-1.1992",
  "connections-embed-lib": "/connections-embed-lib/static-1.1184",
  "copilot-toolkit": "/copilot-toolkit/static-1.11397",
  "feedback-loader": "/feedback-loader/static-1.29488",
  "laboratory-lib": "/laboratory-lib/static-3.7258",
  "marketplace-embed": "/marketplace-embed/static-1.22416",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10016",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20076",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14291",
  "sanitize-text": "/sanitize-text/static-1.8250",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8809",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5868",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5140",
  "wootric-nps": "/wootric-nps/static-1.7060",
  "quartz-head": "/quartz-head/static-1.827",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4758",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4257",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "reporting-data": "/reporting-data/static-1.67968",
  "cssUtils": "/cssUtils/static-1.822",
  "flux-actions": "/flux-actions/static-1.345",
  "HubStyle": "/HubStyle/static-2.11887",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10314",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10468",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7444",
  "icons": "/icons/static-2.653",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18653",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4618",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5620",
  "quartz-i18n": "/quartz-i18n/static-1.837",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.333",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.537",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.673",
  "slack-ui-library": "/slack-ui-library/static-1.10500",
  "fsm": "/fsm/static-1.3835",
  "customer-data-objects": "/customer-data-objects/static-1.7785",
  "property-translator": "/property-translator/static-1.5503",
  "hs-locale-management": "/hs-locale-management/static-1.159",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8033",
  "hs-promise-utils": "/hs-promise-utils/static-1.5697",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4984",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13902",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5712",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7889",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4582",
  "superstore": "/superstore/static-1.4866",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10332",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8051",
  "hub-http-janus": "/hub-http-janus/static-1.843",
  "hubspotter-http": "/hubspotter-http/static-1.4728",
  "immutable-less": "/immutable-less/static-1.4759",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17528",
  "nav-meta": "/nav-meta/static-1.29905",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18139",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3922",
  "property-management-common": "/property-management-common/static-1.5802",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9170",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.542",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.837",
  "quartz-test": "/quartz-test/static-1.837",
  "quartz-tracking": "/quartz-tracking/static-1.541",
  "trellis-components": "/trellis-components/static-1.2201",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.171",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21787",
  "ContentUtils": "/ContentUtils/static-1.68655",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13136",
  "sassPrefix": "/sassPrefix/static-1.158",
  "breeze-engine-core": "/breeze-engine-core/static-1.350",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.216",
  "avatar-components": "/avatar-components/static-1.2604",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40139",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13278",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14672",
  "ExportDialog": "/ExportDialog/static-6.10486",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41561",
  "reporting-snowflake": "/reporting-snowflake/static-1.56586",
  "reporting-ui-components": "/reporting-ui-components/static-2.65239",
  "reporting-visualizations": "/reporting-visualizations/static-1.60044",
  "trellis-theming": "/trellis-theming/static-1.1047",
  "ui-addon-teams": "/ui-addon-teams/static-1.21688",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.157",
  "magpie-lib": "/magpie-lib/static-1.5621",
  "navigation-components": "/navigation-components/static-1.18268",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1072",
  "magpie-types": "/magpie-types/static-1.5081",
  "simple-logging-lib": "/simple-logging-lib/static-1.3156",
  "ai-studio-lib": "/ai-studio-lib/static-1.11912",
  "app-governance-lib": "/app-governance-lib/static-1.1878",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10620",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8111",
  "ui-product-approvals": "/ui-product-approvals/static-1.28566",
  "ui-tool-access": "/ui-tool-access/static-1.10254",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9377",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5871",
  "usage-tracker-public": "/usage-tracker-public/static-1.7265",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3663",
  "persist-promise": "/persist-promise/static-1.3805",
  "reference-resolvers": "/reference-resolvers/static-1.8280",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4031",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.443",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3124",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3065",
  "atom": "/atom/static-1.5180",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6075",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1648",
  "crm-component-utils": "/crm-component-utils/static-1.39348",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5995",
  "customer-data-properties": "/customer-data-properties/static-1.51929",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6997",
  "property-value-citations": "/property-value-citations/static-1.2543",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8204",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9168",
  "navigation-messaging": "/navigation-messaging/static-1.7595",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10213",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4919",
  "content-icons-ui": "/content-icons-ui/static-1.2256",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9931",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7354",
  "crm-message-bus": "/crm-message-bus/static-1.43245",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22574",
  "events-data-lib": "/events-data-lib/static-1.338",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4827",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4081",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6902",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1088",
  "onboarding-tours": "/onboarding-tours/static-1.16795",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13972",
  "academy-common-lib": "/academy-common-lib/static-1.14132",
  "content-assistance-lib": "/content-assistance-lib/static-1.7918",
  "dashboard-lib": "/dashboard-lib/static-1.81930",
  "file-manager-components": "/file-manager-components/static-1.23902",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18697",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18515",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18507",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20010",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8810",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4866",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11168",
  "user-context": "/user-context/static-1.5216",
  "growth-payments-core": "/growth-payments-core/static-1.25678",
  "reporting-plugins": "/reporting-plugins/static-1.10495",
  "reporting-reports": "/reporting-reports/static-1.67646",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.831",
  "nest": "/nest/static-1.338",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10733",
  "framework-listing-lib": "/framework-listing-lib/static-2.28981",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30957",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4358",
  "react-dnd-compat": "/react-dnd-compat/static-1.4721",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.461",
  "onboarding-scopes": "/onboarding-scopes/static-1.6566",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5009",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7749",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15056",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3666",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9560",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6078",
  "signup-constants": "/signup-constants/static-1.19082",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8163",
  "card-properties-lib": "/card-properties-lib/static-1.44500",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37391",
  "crm-actions": "/crm-actions/static-1.6445",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43883",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9542",
  "customer-data-tracking": "/customer-data-tracking/static-1.6995",
  "hs-resources": "/hs-resources/static-1.279",
  "pulse": "/pulse/static-1.702",
  "calling-global-api": "/calling-global-api/static-1.64864",
  "calling-internal-common": "/calling-internal-common/static-1.31416",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66246",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58540",
  "commerce-products-lib": "/commerce-products-lib/static-1.9929",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3873",
  "crm-links": "/crm-links/static-1.6413",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4215",
  "external-options-client-types": "/external-options-client-types/static-1.4206",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4294",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.740",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3767",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49097",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4043",
  "smart-property-lib": "/smart-property-lib/static-1.7739",
  "tiered-pricing": "/tiered-pricing/static-1.1477",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11095",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.116",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1136",
  "growth-data-modal": "/growth-data-modal/static-1.5593",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3171",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2218",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.861",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7713",
  "academy-service-client": "/academy-service-client/static-1.3789",
  "SafeStorage": "/SafeStorage/static-1.4505",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39401",
  "FileManagerLib": "/FileManagerLib/static-1.39542",
  "video-embed": "/video-embed/static-1.36103",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28845",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11611",
  "video-data-lib": "/video-data-lib/static-1.35269",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23790",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9992",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24598",
  "viral-links-lib": "/viral-links-lib/static-1.7175",
  "data-token-picker": "/data-token-picker/static-1.16589",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.329",
  "timezone-utils": "/timezone-utils/static-2.5348",
  "seat-types-lib": "/seat-types-lib/static-1.251",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17815",
  "ui-addon-opt": "/ui-addon-opt/static-4.8467",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9390",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25658",
  "framework-data-table": "/framework-data-table/static-2.12149",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6972",
  "nudge-client-utils": "/nudge-client-utils/static-1.2797",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1210",
  "switchboard-lib": "/switchboard-lib/static-1.329",
  "app-users-service-client": "/app-users-service-client/static-1.5714",
  "app-users-service-types": "/app-users-service-types/static-1.5122",
  "mini-checkout-client": "/mini-checkout-client/static-1.27066",
  "onboarding-utils": "/onboarding-utils/static-1.5465",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28830",
  "edison-service-client-types": "/edison-service-client-types/static-1.495",
  "crm_data": "/crm_data/static-4.92280",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46296",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16857",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4365",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1204",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19410",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18777",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10651",
  "crm-fe-perf": "/crm-fe-perf/static-1.23010",
  "event-emitter": "/event-emitter/static-1.1056",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.205",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31423",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11141",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6649",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1400",
  "commerce-permissions": "/commerce-permissions/static-1.883",
  "products-iframe-lib": "/products-iframe-lib/static-1.8218",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10597",
  "data-agent-kit": "/data-agent-kit/static-1.363",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10298",
  "policy-lib": "/policy-lib/static-1.6888",
  "react-tinymce": "/react-tinymce/static-1.55513",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10361",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54639",
  "tinymce-plugins": "/tinymce-plugins/static-1.57753",
  "tinymce-themes": "/tinymce-themes/static-1.56609",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2138",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2246",
  "user-context-client": "/user-context-client/static-1.4687",
  "audio-components": "/audio-components/static-1.6075",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37053",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4642",
  "video-components": "/video-components/static-1.13613",
  "outpost": "/outpost/static-1.4276",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6685",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12636",
  "content-media-compositions": "/content-media-compositions/static-2.16643",
  "media-bridge-lib": "/media-bridge-lib/static-1.19105",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6288",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5187",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3698",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21857",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3955",
  "ts-utils-lib": "/ts-utils-lib/static-1.278",
  "crm-export-dialog": "/crm-export-dialog/static-1.6391",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6547",
  "crm-view-components": "/crm-view-components/static-1.586",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7436",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2554",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2873",
  "whisper-core-api": "/whisper-core-api/static-1.6845",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15080",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5777",
  "settings-content-modals": "/settings-content-modals/static-1.46371",
  "crm_universal": "/crm_universal/static-1.22189",
  "customer-data-email": "/customer-data-email/static-1.18218",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37461",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39814",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12565",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55058",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21748",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18212",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72357",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5449",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9811",
  "utility-belt": "/utility-belt/static-1.2638",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23214",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7691",
  "customer-data-rte": "/customer-data-rte/static-1.33264",
  "cv-backend-services": "/cv-backend-services/static-1.1558",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5929",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5212",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38447",
  "trials-service-types": "/trials-service-types/static-1.3987",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36177",
  "sales-views-client-types": "/sales-views-client-types/static-1.4362",
  "hub-http-contrib": "/hub-http-contrib/static-1.3148",
  "interframe": "/interframe/static-3.4866",
  "tinymce-data": "/tinymce-data/static-1.40724",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5316",
  "layout-dnd-components": "/layout-dnd-components/static-1.12643",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11618",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15644",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9133",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7710",
  "social-insights-client-types": "/social-insights-client-types/static-1.22323",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4273",
  "checkout-sdk": "/checkout-sdk/static-3.23909",
  "checkout-service-types": "/checkout-service-types/static-1.3874",
  "company-details-components": "/company-details-components/static-1.6303",
  "payment-method-components": "/payment-method-components/static-1.6979",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14657",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3570",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3628",
  "access-control-lib": "/access-control-lib/static-1.10540",
  "EmailComponents": "/EmailComponents/static-1.55049",
  "EmailData": "/EmailData/static-1.53726",
  "redux-less": "/redux-less/static-2.9588",
  "sequences-lib": "/sequences-lib/static-1.8227",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10457",
  "products-ui-components": "/products-ui-components/static-1.40447",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7232",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55074",
  "commerce-products-api": "/commerce-products-api/static-1.2445",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57132",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103035",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81078",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28533",
  "ContentData": "/ContentData/static-1.68730",
  "layout-data-lib": "/layout-data-lib/static-1.9943",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.808",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4043",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4097",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.661",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18710",
  "pricing-pages-api": "/pricing-pages-api/static-1.14522",
  "ContentComponents": "/ContentComponents/static-2.71611",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10387",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1982",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46558",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1420",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19178",
  "automation-ui-types": "/automation-ui-types/static-1.20096",
  "messaging-types-lib": "/messaging-types-lib/static-1.46295",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4608",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8084",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.642",
  "price-books-api": "/price-books-api/static-1.1202",
  "price-books-components": "/price-books-components/static-1.1260",
  "property-description-translator": "/property-description-translator/static-1.3947",
  "ramp-editor": "/ramp-editor/static-1.411",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3686",
  "totals-ui-components": "/totals-ui-components/static-1.23876",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9393",
  "advanced-menus-core": "/advanced-menus-core/static-1.15295",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12209",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34321",
  "segments-query-core": "/segments-query-core/static-1.1526",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6012",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7444",
  "data-token-views": "/data-token-views/static-1.16570",
  "forms-utils-lib": "/forms-utils-lib/static-1.12777",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13246",
  "simple-menus-core": "/simple-menus-core/static-1.15294",
  "simple-menus-lib": "/simple-menus-lib/static-1.16811",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6967",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7619",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2629",
  "ContentEditorUI": "/ContentEditorUI/static-2.77395",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4030",
  "web-interactives-components": "/web-interactives-components/static-1.13941",
  "web-interactives-data": "/web-interactives-data/static-1.13942",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.869",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1039",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1082",
  "line-items-api": "/line-items-api/static-1.847",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3895",
  "FireAlarmUi": "/FireAlarmUi/static-1.4585",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4246",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22032",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21495",
  "data-studio-ubb": "/data-studio-ubb/static-1.3016",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27252",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58139",
  "content-management-data-lib": "/content-management-data-lib/static-1.5578",
  "copilot-plugins": "/copilot-plugins/static-1.11370",
  "cta-picker": "/cta-picker/static-1.36670",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3380",
  "editor-components": "/editor-components/static-1.13377",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8544",
  "error-messaging-js": "/error-messaging-js/static-1.5297",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10752",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1851",
  "smart-content-core": "/smart-content-core/static-1.42717",
  "smart-content-lib": "/smart-content-lib/static-1.43370",
  "social-composer-lib": "/social-composer-lib/static-1.59525",
  "structured-content-lib": "/structured-content-lib/static-1.25461",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53521",
  "tinymce-copilot": "/tinymce-copilot/static-1.16707",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8043",
  "automation-ui-routing": "/automation-ui-routing/static-1.21453",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5721",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42414",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3295",
  "reporting-enablement": "/reporting-enablement/static-1.23277",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21778",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2936",
  "forms-ai-lib": "/forms-ai-lib/static-1.4481",
  "codemirror-dlb": "/codemirror-dlb/static-1.58954",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6541",
  "report-customization-components": "/report-customization-components/static-1.13449",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13300",
  "reporting-filters": "/reporting-filters/static-1.577",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2041"
}
};
